export const DermTreatmentHeader = [
  "intake_surveys.SURVEYMNEMONIC_DACNE.SECTIONMNEMONIC_DACNE_TREAT.d_9_1",
  "intake_surveys.SURVEYMNEMONIC_DRASH.SECTIONMNEMONIC_DRASH_TREAT.d_17_1",
  "intake_surveys.SURVEYMNEMONIC_DMOLE.SECTIONMNEMONIC_DMOLE_TREAT.d_23_1"
];

export const FILTER_OPTIONS_FIELD = {
  name: "filter_options",
  type: "expandoField"
};

export const CALENDAR_OPTIONS_FIELD = {
  name: "request_date",
  type: "formCalendarPicker"
};

export const DATE_ONLY_FORMAT = "ddd MMM DD, YYYY";
export const PULSE_DATE_ONLY_FORMAT = "M/D/yyyy";

export const DATE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
export const TIME_12H_FORMAT = "hh:mm A";
export const DEFAULT_DOB_FORMAT = "MM/DD/YYYY";

export const DEFAULT_UPPER_LIMIT = 10000;
export const CALL_TO_ACTION_BUTTON_TYPES = {
  goToPreviousScreen: "pop_flow"
};

export const PHOTO_MODAL_SCREEN_NAMES = {
  pulseRavCase: "PulseConsultationPhotoModal",
  ravCase: "ConsultationPhotoModal",
  medicalInfoSection: "PhotoModal",
  emoCase: "EmoCasePhotoModal",
  mhNavigatorCase: "MentalHealthNavigatorCasePhotoModal",
  EliteDiagnosticCase: "EliteDiagnosticImagingServicePhotoModal"
};

export const ULRS_TO_REMOVE_FROM_HISTORY = [
  "/screens/billing",
  "/screens/emergency_contact",
  "/screens/authorized_consenters",
  "screens/request_consult/verify_insurance"
];

export const CONSENT_VALIDATION_FIELD = {
  name: "you_will_be_unable_to_complete",
  type: "text"
};

export const CALENDAR_COPIES = {
  dateGroupErrorMessage: "Visit date",
  timeGroupErrorMessage: "visit time"
};

export const CONSENT_VALIDATION_MESSAGES = {
  missingConsent: "missing_consent",
  missingIntake: "missing_intake_form",
  generalMessage: "full_message"
};

export const RESETTABLE_MODAL_SCREENS = ["AccountCareRecipientsNew"];
export const DIALOG_HEADING_ID = "dialog-heading";
export const CHIPS_PARAMS = {
  selectSingleChip: "TDFieldOptionSelectSingleSuggestionChip",
  highlightChip: "TDActionNavHighlightSuggestionChip",
  toggleChip: "TDFieldOptionToggleSuggestionChip"
};

export const FIELD_NAMES = {
  searchBy: "searchBy",
  selectPharmacyError: "select_pharmacy_error",
  submit: "submit",
  pharmacyMap: "pharmacyMap",
  manualPharmacy: "manualPharmacy",
  pharmacyId: "pharmacy_id",
  email: "email",
  primaryPhone: "primary_phone",
  phoneNumber: "phone_number",
  otherPhoneNumber: "other_phone_number",
  alternatePhoneNumber: "alternate_phone_number",
  automatedCall: "automated_call",
  textNotification: "text_notification",
  textNotificationOther: "text_notification_other",
  automatedCallOther: "automated_call_other",
  agreementPPN: "agreements.AGREEMENT_PPN",
  canPrescribe: "can_prescribe",
  resetFilter: "reset_filter",
  removeButton: "removeButton",
  dependentsTitle: "dependents_title",
  dependentsTitleField: "dependents_title_field",
  dependentsAddField: "dependents_add_field",
  authorizedConsenterTitle: "authorized_consenter_title",
  authorizedConsenterTitleField: "authorized_consenter_title_field",
  authorizedConsenterAddField: "authorized_consenter_add_field",
  careRecipientsTitle: "care_recipients_title",
  careRecipientsTitleField: "care_recipients_title_field",
  careRecipientsAddField: "care_recipients_add_field",
  lowercaseLetterRequired: "lowercase_letter_required",
  atLeastOneNumber: "at_least_one_number",
  characterLength: "character_length"
};

export const TEXT_NOTIFICATION_VALUES = {
  doNotContact: "DO_NOT_CONTACT",
  off: "off",
  addNew: "Add new"
};

export const FIELD_PARAMS = {
  fieldOptionHidden: "TDFieldOptionHidden",
  fieldOptionReadRequired: "TDFieldOptionReadRequired",
  fieldOptionMonth: "TDFieldOptionMonth",
  fieldOptionYear: "TDFieldOptionYear",
  fieldOptionEmail: "TDFieldOptionEmail",
  fieldOptionZipCode: "TDFieldOptionZipCode"
};

export const SCREEN_PARAMS = {
  screenOptionPharmacyList: "TDScreenOptionPharmacyList"
};

export const FIELD_TYPES = {
  formCheckboxContainer: "formCheckboxContainer",
  containerSpacer: "containerSpacer",
  formRadioButtons: "formRadioButtons",
  expandoField: "expandoField",
  cellWithSwitch: "cellWithSwitch",
  modernizedToggle: "modernizedToggle",
  modernizedTextField: "modernizedTextField",
  container: "container",
  formTextField: "formTextField"
};

export const FIELD_POSITION = {
  above: "above",
  below: "below"
};

export const ACTION_TYPES = {
  selector: "selector"
};

export const ACTION_VALUES = {
  nextPaginationPage: "nextPaginationPage",
  previousPaginationPage: "previousPaginationPage",
  onTemplatedListItemSelected: "onTemplatedListItemSelected",
  selectMarker: "selectMarker"
};

export const ACTION_PARAMS = {
  navDropScreens: "TDActionNavDropScreens"
};

export const VIEW_SELECTOR_TYPES = {
  map: "MAP",
  list: "LIST"
};

export const REPLY_BUTTON = {
  name: "replyButton",
  action: {
    value: "MessageCenterReplyModal",
    type: "modal_screen",
    typeOverride: "screen"
  }
};

export const SCREENS_WITH_SPACERS = [
  "ConsultationRecentProviders",
  "EnhancedSchedulingProviderList",
  "ConsultationConfirmation",
  "ConsultationBhRecentProviders",
  "ConsultationBhProviderProfile",
  "ConsultationOption",
  "ConsultationBhSchedule",
  "ConsultationMembers",
  "Payment",
  "PaymentCardShorten",
  "CareTeamMembersList",
  "VisitCancellation"
];

export const PRE_PHOTO_MODAL_SCREENS = [
  "ConsultationDermImages",
  "ConsultationImagesPcp",
  "FileUploads",
  "SharedImagesUpload",
  "AdvanceMedicalAppointmentInfoDetails",
  "VisitMhMinorConsent",
  "MhMinorManualIntake"
];

export const SCREENS_WITH_MULTIPLE_PHOTO_PICKERS = ["InsuranceCapture"];

export const INVALID_URL_MESSAGE = "property in appConfiguration is not valid";

export const PAYMENT_BUTTON_PROPS = {
  name: "existingCardButton"
};

export const LAYOUT_IDS = {
  primary: "primary"
};

export const SCREENS_WITHOUT_ASTERISK = [
  "AuthorizationLogin",
  "SelectCoverage"
];

export const SCREENS_WITHOUT_BACK_BUTTON = [
  "ActivationDependentSuccess",
  "ConsultationMembers",
  "FindBestDoctorSubmitConfirmation",
  "PrimaryCareProviderSelectionSuccess",
  "CareTeamMembersList",
  "SuccessBpCuffShipmentAddressUpdate",
  "SuccessBpCuffShipmentOptOut",
  "AuthorizationLogin",
  "UnifiedRegistrationLoginCredentials",
  "SelectCoverage",
  "ConfirmAddress",
  "ShoppingCartScreenSetting",
  "WelcomeBack"
];

export const CASES_TABLE = {
  noneText: "None"
};

export const DIALOG_NAMES = {
  screenDefault: "screenDefault"
};

export const WCAG_ADOPTED_TEXT = "TDFieldOptionWcagAdopted";

export const ARIA_ROLES = {
  radio: "radio"
};

export const FIELDS_WITHOUT_REQUIRED_VALIDATION = [
  "zip_code",
  "postal_code",
  "postal_code_can",
  "postal_code_dnk"
];

export const EXPANDO_OPTION_TEST_IDS = {
  optionsWrapper: "EXPANDO_OPTION_TEST_ID_OPTIONS_WRAPPER",
  button: "EXPANDO_OPTION_TEST_ID_BUTTON"
};

export const EXPANDED_CLASSNAME = "expanded";
export const INVALID_CLASSNAME = "invalid";
export const MODERNIZED_MODAL_HEADING_ID = "modernized-modal-heading";
export const MODERNIZED_MODAL_DISMISS_ANIMATION_TIME = 800;
export const MODERNIZED_MODAL_ANIMATION_TIME = 300;
export const MODERNIZED_MODAL_SMALL_SCREEN = 576;

export const DEFAULT_SPECIALTIES_DATA = {
  "specialties.0": "",
  "specialties.1": "",
  "specialties.2": ""
};

export const CLEAR_SPECIALTIES_TAG = "TAGClearSpecialtiesInput";

export const CAN_PRESCRIBE_NAME = "can_prescribe";

export const CREDIT_CARD_FIELDS = {
  creditCardValue: "credit_card_value",
  maskedCardNumber: "cc_info.masked_card_number",
  updatePaymentLink: "update_payment_link",
  creditCardIcon: "credit_card_icon",
  changeToCard: "change_to_card"
};

export const SHORTEN_FLOW_PAYMENT_SCREENS = {
  paymentCardShorten: "PaymentCardShorten",
  paymentPaypalShorten: "PaymentPaypalShorten",
  paymentNoCardShorten: "PaymentNoCardShorten"
};

export const PAYPAL_VALUE = "PayPal";

export const PAYMENT_ICONS = {
  pulsePaypal: "ic_pulse_paypal",
  creditCardDefault: "ic_pulse_credit_card_default"
};
export const INPUT_UPDATE_TIMEOUT = 100;

export const CONFIRMATION_SCREENS = [
  "AdvanceMedicalRequestAppointmentConfirmation",
  "AdvanceMedicalCallMeBackConfirmation",
  "AdvanceMedicalAddDependentConfirmation",
  "AdvanceMedicalDashboard"
];

export const SHORTEN_FLOW_DEPENDANT_SCREENS = [
  "ConsultationContactInfoShorten",
  "PaymentCardShorten",
  "PaymentPaypalShorten",
  "ConsultationPaymentCardEntryShorten"
];

export const PHONE_FIELD = {
  phoneNumber: "phoneNumber"
};

export const DFD_TEXTAREA_MAX_LENGTH = "250";

export const CLEAR_SPECIALTIES = "clearSpecialties";

export const ALLERGY_REACTANT_NAME = "allergy_reactantName";

export const PREVENT_SELECTED_FIELD_OPTION_UPDATE = [
  "medication_frequency",
  ALLERGY_REACTANT_NAME
];

export const APP_DATA_VALUE_KEYS = {
  loggedInMemberId: "logged_in_member_id",
  minThreshold: "min_threshold",
  maxThreshold: "max_threshold",
  thresholdSliderHigh: "threshold_slider_high",
  thresholdSliderLow: "threshold_slider_low"
};

export const SCREEN_SIZE_LANDING_BACK_BUTTON = 720;

export const UNIFIED_PROFILE_PARAMS = {
  landingPage: "TDScreenLandingPage"
};

export const SCREEN_SIZE_BREAKPOINTS = {
  xs: 375,
  sm: 576,
  md: 768
};

export const DFD_CAROUSEL_SLIDE_WIDTH = "343px";
